import { render, staticRenderFns } from "./editCustomsFile.vue?vue&type=template&id=1ad5768f&"
import script from "./editCustomsFile.vue?vue&type=script&lang=js&"
export * from "./editCustomsFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ad5768f')) {
      api.createRecord('1ad5768f', component.options)
    } else {
      api.reload('1ad5768f', component.options)
    }
    module.hot.accept("./editCustomsFile.vue?vue&type=template&id=1ad5768f&", function () {
      api.rerender('1ad5768f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/editCustomsFile.vue"
export default component.exports